(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-teams.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-teams.js');
"use strict";


const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const fetchTeams = svs.components.marketplaceCompetition.services.actions.teamsActions.fetchTeams;
const selectTeams = svs.components.marketplaceCompetition.services.selectors.selectTeams;
const usePlayerCompetitions = svs.components.marketplaceCompetition.services.hooks.usePlayerCompetitions;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const useTeams = competitionId => {
  const dispatch = useDispatch();
  const playerCompetitions = usePlayerCompetitions();
  const playerCompetitionIds = Object.keys(playerCompetitions);
  const competitionIds = playerCompetitionIds.map(compId => parseInt(compId, 10));
  const isParticipating = playerCompetitions && competitionIds.find(id => id === competitionId);
  const _useSelector = useSelector(state => selectTeams(state, competitionId)),
    teams = _useSelector.data,
    status = _useSelector.status;
  const currentCompetition = isParticipating ? playerCompetitions[isParticipating] : null;
  const teamsData = {
    teams,
    status: status || FetchState.Pending
  };
  const memoizedTeams = useMemo(() => teamsData
  , [teams, status]);
  useEffect(() => {
    if (isParticipating && currentCompetition && !currentCompetition.isDirty) {
      dispatch(fetchTeams(competitionId));
    }
  }, [competitionId, currentCompetition, dispatch, isParticipating]);
  return memoizedTeams;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useTeams', useTeams);

 })(window);